import templateUrl from './slider.html';

export const sliderComponent = {
	templateUrl,

	bindings: {
		details: '<'
	},

	controller: class SliderComponent {
		constructor($parse, $window) {
			'ngInject';

			this.$parse = $parse;
			this.carouselObj = {
				myInterval: 5000,
				noWrapSlides: false,
				active: 0
			}
			this.$window = $window;
		}

		getHyperlinkTarget(url) {
			const currentHostName = this.$window.location.hostname;
			const hostNameOfGivenUrl = this._getHostnameFromUrl(url);
			return (currentHostName.toLowerCase() !== hostNameOfGivenUrl.toLowerCase()) ? '_blank' : '_self';
		}

		//**********************************************Private Methods*********************************** */

		_getHostnameFromUrl(url) {
			const match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
			if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
				return match[2];
			}
			else {
				return '';
			}
		}
	}
};


// WEBPACK FOOTER //
// ./src/app/common/components/slider/slider.component.js